import React from "react";
import {
  Box,
  FormControl,
  FormLabel,
  Select,
  MenuItem,
  Typography,
  Tooltip,
} from "@mui/material";
import { InfoOutline } from "@mui/icons-material";
import IOSSwitch from "../../../common/Switch";
import HPInput from "../../../common/Input";

interface DataSortingSectionProps {
  dataSorting: "ascending" | "descending" | "none" | "custom";
  topNResponses: boolean;
  topNValue: number;
  combineRemainingIntoOther: boolean;
  onDataSortingChange: (
    value: "ascending" | "descending" | "none" | "custom",
  ) => void;
  onTopNResponsesChange: (params: { enabled: boolean; value?: number }) => void;
  onCombineRemainingChange: (value: boolean) => void;
}

const DataSortingSection: React.FC<DataSortingSectionProps> = ({
  dataSorting,
  topNResponses,
  topNValue,
  combineRemainingIntoOther,
  onDataSortingChange,
  onTopNResponsesChange,
  onCombineRemainingChange,
}) => {
  return (
    <Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <FormControl fullWidth size="small">
          <FormLabel className="text-[12px] text-[#262626]">
            Data sorting
          </FormLabel>
          <Select
            value={dataSorting}
            onChange={(e) =>
              onDataSortingChange(
                e.target.value as "ascending" | "descending" | "none" | "custom",
              )
            }
          >
            <MenuItem value="descending">Descending %</MenuItem>
            <MenuItem value="ascending">Ascending %</MenuItem>
            <MenuItem value="none">Original survey order</MenuItem>
            <MenuItem value="custom">Custom order</MenuItem>
          </Select>
        </FormControl>

        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            <IOSSwitch
              checked={topNResponses}
              onChange={(e) =>
                onTopNResponsesChange({ enabled: e.target.checked })
              }
              size="small"
            />
            <Typography>Top N responses</Typography>
            <Tooltip title="Show only responses with the highest percentages overall ">
              <InfoOutline
                sx={{ fontSize: 16, color: "text.secondary" }}
              />
            </Tooltip>
          </Box>
        </Box>

        {topNResponses && (
          <>
            <HPInput
              label="Amount of visible bars"
              type="number"
              value={String(topNValue)}
              onChange={(e) =>
                onTopNResponsesChange({
                  enabled: true,
                  value: parseInt(e.target.value),
                })
              }
            />
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Box
                sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
              >
                <Typography>Combine remaining into Other</Typography>
                <Tooltip title="Combine all remaining responses beyond Top N into a single 'Other' category">
                  <InfoOutline
                    sx={{ fontSize: 16, color: "text.secondary" }}
                  />
                </Tooltip>
              </Box>
              <IOSSwitch
                checked={combineRemainingIntoOther}
                onChange={(e) => onCombineRemainingChange(e.target.checked)}
                size="small"
              />
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
};

export default DataSortingSection;
